<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6941 3.44412L21.5559 7.30587C21.8409 7.59087 22 7.97563 22 8.37937V15H20.5H20.29V8.45775L17.06 5.22775V7.94C17.06 8.36037 16.7204 8.7 16.3 8.7H8.7C8.27962 8.7 7.94 8.36037 7.94 7.94V4.71H4.71V20.29H16V20.5V22H3.76C3.33962 22 3 21.6604 3 21.24V3.76C3 3.33962 3.33962 3 3.76 3H17.06V3.06412C17.2975 3.13537 17.516 3.266 17.6941 3.44412ZM15.54 4.71H9.46V7.18H15.54V4.71ZM9.08 14.2575C9.08 12.3694 10.6119 10.8375 12.5 10.8375C14.3881 10.8375 15.92 12.3694 15.92 14.2575C15.92 16.1456 14.3881 17.6775 12.5 17.6775C10.6119 17.6775 9.08 16.1456 9.08 14.2575ZM10.6 14.2575C10.6 15.3073 11.4502 16.1575 12.5 16.1575C13.5498 16.1575 14.4 15.3073 14.4 14.2575C14.4 13.2077 13.5498 12.3575 12.5 12.3575C11.4502 12.3575 10.6 13.2077 10.6 14.2575Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17 17C17 16.4477 17.4477 16 18 16H23C23.5523 16 24 16.4477 24 17V23C24 23.5523 23.5523 24 23 24H18C17.4477 24 17 23.5523 17 23V17ZM19 20H22V21H19V20ZM22 18H19V19H22V18Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGSaveAsCopy',
};
</script>

<style scoped lang="scss">

</style>
